module.exports = __webpack_public_path__ + "static/media/Baby - Charcoal and Pastel.54a112e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Baby - Charcoal and Pastel.jpg
 ** module id = 384
 ** module chunks = 0
 **/